import React from "react";
import {useTranslation} from "react-i18next";
import MessageString from "./MessageString";
import MessagesArray from "./MessagesArray";


const ChatMessage = ({message, snActions}) => {

	const {t} = useTranslation();
	return (
					Array.isArray(message?.content) ? (
							<MessagesArray
									msData={message}
									snActions={snActions}
									messages={message?.content?.map((item, index) => ({...item, id: index+1}))}
							/>
					):(
							<MessageString message={message} snActions={snActions}/>
					)
	);
};

export default ChatMessage;
